import { render, staticRenderFns } from "./ModalFilterPremiumMarketLayout.vue?vue&type=template&id=5d8a5dfd&scoped=true"
import script from "./ModalFilterPremiumMarketLayout.vue?vue&type=script&lang=js"
export * from "./ModalFilterPremiumMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a5dfd",
  null
  
)

export default component.exports